export const NUM_CURATED_TRAILS = 400; // thousand
export const NUM_USERS = 45; // million
export const LOGGED_DISTANCE = 1126540.8; // meters
